module.exports = __webpack_public_path__ + "static/media/vaccine.1fa58139.png";